import e, { memo as b, useCallback as p } from "react";
import { useTheme as f, useMultiStyleConfig as g, BreadcrumbItem as c, BreadcrumbLink as x, BreadcrumbSeparator as h, Box as k } from "@chakra-ui/react";
import { Icon as C } from "../../atoms/icon/icon.js";
import "@loadable/component";
import { MdChevronRight as E } from "@react-icons/all-files/md/MdChevronRight";
import { MdChevronLeft as y } from "@react-icons/all-files/md/MdChevronLeft";
import "@chakra-ui/system";
import { getRelAttributeAccordingToUrl as B } from "../../../utils/externalUrlChecker.js";
const H = b(
  ({ element: r, buttonClickHandler: n, variant: i = null }) => {
    const {
      badgeIconSize: o,
      breadcrumbs: { paddingHorizontal: u },
      linkDefault: d
    } = f(), t = g("BreadcrumbItem", {
      variant: i
    }), l = i === "singular" ? y : E, s = p(
      (a, m) => {
        a.preventDefault(), m && n(m);
      },
      []
    );
    return r.url ? /* @__PURE__ */ e.createElement(
      c,
      {
        "data-item-id": `breadcrumb-item-${r.text}`,
        key: `breadcrumb-item-${r.text}`,
        sx: t.item
      },
      /* @__PURE__ */ e.createElement(
        x,
        {
          href: r.url,
          rel: B(r.url),
          onClick: (a) => s(a, r.url || ""),
          textDecoration: "underline",
          sx: t.link
        },
        r.text
      ),
      /* @__PURE__ */ e.createElement(
        h,
        {
          paddingRight: u,
          display: "flex",
          alignItems: "center",
          sx: t.separator
        },
        /* @__PURE__ */ e.createElement(
          C,
          {
            as: l,
            h: o,
            w: o,
            "aria-hidden": "true"
          }
        )
      )
    ) : /* @__PURE__ */ e.createElement(
      c,
      {
        isCurrentPage: !0,
        "data-item-id": "breadcrumb-item-current",
        key: "breadcrumb-item-current"
      },
      /* @__PURE__ */ e.createElement(k, { as: "span", "aria-current": "page", ...d }, r.text)
    );
  }
);
export {
  H as Crumb
};
